module.exports = __webpack_public_path__ + "static/media/glanum_kenotaph_tn.a25ef147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_kenotaph_tn.jpg
// module id = 718
// module chunks = 0